/**
 * PresentationEditor.tsx — authors spec.presentation.html (the in-app result
 * screen). Rich HTML + chip palette derived from the live config.
 */

import HtmlChipEditor from './HtmlChipEditor';
import { StudioPanel } from './ui';
import type { CalcSpec, StudioInputField } from '../../../api/calculatorBuilder';

interface Props {
  spec: CalcSpec;
  inputs: StudioInputField[];
  css?: string;
  onChange: (html: string) => void;
}

export default function PresentationEditor({ spec, inputs, css, onChange }: Props) {
  return (
    <StudioPanel
      title="Presentation (result screen)"
      subtitle="Rendered on the web result page + mobile. Insert chips for inputs, outputs and recommendation slots."
    >
      <HtmlChipEditor
        html={spec.presentation?.html ?? ''}
        spec={spec}
        inputs={inputs}
        css={css}
        onChange={onChange}
      />
    </StudioPanel>
  );
}
